// extracted by mini-css-extract-plugin
export default {"cls1":"ClhPRBQnR_26QYmcCo1h","cls2":"yGxbZ1rwG2Vbsc5iODnL ClhPRBQnR_26QYmcCo1h","bookingAppRedesign":"Xj_W3ftIrqHr_rFch4Yc"};